module.exports = __webpack_public_path__ + "img/James Colades.57fb5b5d.jpg";